export default __webpack_public_path__ + "4e0fe495d2befbbb13bb1073814fdca3.svg";